import styled from 'styled-components';

const StyledAppointmentContainer = styled.div`
  margin-top: -3.2rem;
  margin-bottom: 1.2rem;
`;

export default StyledAppointmentContainer;
